export interface JobBrief {
  jobId: string
  appliance: string
  orderNumber: string
  address: string
  customer: string
  provider: string
  installer: string
  intake: { key: string; value: string }[]
  risk: { title: string; body: string; source: string }
  stageParts: string[]
  tools: string[]
  heroSrc: string
}

export const JOB: JobBrief = {
  jobId: 'JOB-12847',
  appliance: 'GE Profile 24" Built-In Dishwasher',
  orderNumber: '882194',
  address: '1842 19th Avenue E, Seattle, WA 98112',
  customer: 'Sarah Mitchell',
  provider: 'Home Install Network',
  installer: 'James Chen',
  intake: [
    { key: 'Shutoff', value: 'Standard quarter-turn' },
    { key: 'Drain', value: 'Standard hose hookup' },
    { key: 'Drain loop', value: '~18 inches' },
    { key: 'Water pressure', value: 'Normal' },
  ],
  risk: {
    title: 'Older fittings likely at this address',
    body: 'Home profile indicates 2004 build. Treat the supply fitting gently and watch for valve-body movement or hidden seepage after tightening.',
    source: 'Property record',
  },
  stageParts: [
    'Braided stainless supply line',
    'Spare compression ferrule / nut',
    'High-loop clip',
    'Absorbent towels',
  ],
  tools: [
    'Channel-lock pliers',
    'Adjustable wrench',
    'Flashlight',
    'Dry towel / wipe',
    'Floor protection mat',
  ],
  heroSrc: '/proof/ge-dishwasher.avif',
}
